import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "row no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_formula_list_element = _resolveComponent("formula-list-element")!
  const _component_DndProvider = _resolveComponent("DndProvider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('formulas')), 1),
      _createVNode(_component_q_space),
      _createVNode(_component_q_btn, {
        flat: "",
        dense: "",
        "aria-label": _ctx.$t('add_formula'),
        icon: "add",
        size: "sm",
        color: "accent",
        onClick: _ctx.addNewFormula
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, { delay: 1000 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('add_formula')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["aria-label", "onClick"])
    ]),
    _createVNode(_component_DndProvider, {
      backend: _ctx.HTML5Backend,
      context: _ctx._WINDOW_
    }, {
      default: _withCtx(() => [
        _createVNode(_TransitionGroup, {
          name: "list",
          tag: "div"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel, (formula, index) => {
              return (_openBlock(), _createBlock(_component_formula_list_element, {
                key: (formula as ElementFormula).Id+'_f',
                modelValue: _ctx.theModel[index],
                "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                "use-chart-mode": _ctx.useChartMode,
                "input-index": Number(index),
                "formula-options": _ctx.modelValue.filter(el => el.Id !== formula.Id),
                "allow-hover-action": _ctx.allowHoverAction,
                "nested-key-name": _ctx.nestedKeyName,
                "template-name": _ctx.templateName,
                "parameter-options": _ctx.parameterOptions,
                onTheOnlyFormulaLeft: ($event: any) => (_ctx.updateElementName($event, index)),
                onChangePosition: _ctx.moveStoreItem,
                onDeleteFormula: ($event: any) => (_ctx.deleteFormula(index))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "use-chart-mode", "input-index", "formula-options", "allow-hover-action", "nested-key-name", "template-name", "parameter-options", "onTheOnlyFormulaLeft", "onChangePosition", "onDeleteFormula"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["backend", "context"])
  ], 64))
}